import * as React from 'react';
import * as A from 'fp-ts/Array';
import { useRecentLocationsQuery, Location } from '../../generated/graphql';
import { SelectableListItem } from '../../components/SelectableListItem';
import { EdgeContainer } from '../../components/Container';

interface Props {
  teamId: string;
  selectLocation: (
    location: Pick<Location, 'id' | 'address' | 'lat' | 'lng'>,
  ) => void;
}

export const RecentLocationChooser: React.FC<Props> = ({
  teamId,
  selectLocation,
}) => {
  const [recentLocationsRes] = useRecentLocationsQuery({
    variables: { teamId },
  });

  if (
    recentLocationsRes.data?.team?.recentLocations &&
    A.isNonEmpty(recentLocationsRes.data.team.recentLocations)
  ) {
    return (
      <div>
        <h2 className="font-semibold mb-4">Recently used locations</h2>
        <EdgeContainer>
          <ul>
            {recentLocationsRes.data?.team?.recentLocations.map((location) => (
              <SelectableListItem
                key={location.id}
                onClick={() => selectLocation(location)}
              >
                {location.address}
              </SelectableListItem>
            ))}
          </ul>
        </EdgeContainer>
      </div>
    );
  }
  return null;
};
